import { PTO_URL } from '@/api/pto/const'
import { ResponseError } from '@/classes/ResponseError'
import { get } from '@/api/base'

export const PTO_HANDBOOK_ESTIMATE_BASE_TYPES_URL = `${PTO_URL}/estimate-base-types`

export const PTO_HANDBOOK_ESTIMATE_BASE_TYPES_PREFIX = 'App\\Models\\Pto\\'

export function getEstimateBaseTypeKey (value) {
  return value.replace(PTO_HANDBOOK_ESTIMATE_BASE_TYPES_PREFIX, '').toLowerCase()
}

export const EPtoHandbookEstimateBaseTypeName = {
  change: '№ изменения',
  document: 'Документ',
  statement: 'Деф. ведомость'
}

export const PTOHandbookEstimateBaseTypesApi = {
  getAll: async (params) => {
    try {
      return await get(PTO_HANDBOOK_ESTIMATE_BASE_TYPES_URL, params)
    } catch (e) {
      throw new ResponseError(e, 'Не удалось получить список тип основания')
    }
  }
}
